import { Modal, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { AddAddressModalType } from '../Types/AddAddressTypes';
import { AddAddress } from './AddAddress';

function AddAddressModal(props: AddAddressModalType) {
	const { t } = useTranslation();

	return (
		<Modal
			title={t('address.actions.newAddress')}
			isOpen={props.isOpen}
			closeCallback={() => props.closeCallback()}
		>
			<AddAddress
				existingData={props.existingData}
				onAddCallback={(id: number) =>
					props.actionedCallback ? props.actionedCallback(id) : props.closeCallback()
				}
			/>
		</Modal>
	);
}

export { AddAddressModal };
